export { GoogleComponent } from './src/GoogleComponent.js';